import React, { useState } from 'react';

// Material UI
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Add from '@mui/icons-material/Add'

// Components
import { DataGrid, EditButton, DeleteButton } from '@arredo/reactjs-ui';
import CreateAddress from './createAddress';
import ModalConfirm from '../../../../components/modal/confirm';
import ModalSuccess from '../../../../components/modal/submit';

// Hooks
import useCustomer from '../../../../hooks/customers/useCustomer';
import useNotify from '../../../../hooks/notify/index';
import useStyles from "./styles";

const Address = ({ customer, disabled }) => {
    const { classes } = useStyles();
    const [openModal, setOpenModal] = useState(false);
    const [addressToDelete, setAddressToDelete] = useState();
    const [addressToUpdate, setAddressToUpdate] = useState(null);

    const [deleteOpen, setDeleteOpen] = useState(false)
    const [submitOpen, setSubmitOpen] = useState(false)
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const { Notify, variants } = useNotify();

    const { loading, pageNumber, totalPage, changePage, saveAddress, deleteAddress } = useCustomer(customer?.id);

    const columns = [
        {
            field: 'fullAddress',
            header: 'Dirección',
            sizes: { xs: 7 }
        },
        {
            field: 'isInvoice',
            header: 'Dirección de Facturación',
            type: 'boolean',
            sizes: { xs: 2 }
        },
        {
            field: 'isShipping',
            header: 'Dirección de Envio',
            type: 'boolean',
            sizes: { xs: 2 }
        },
    ];

    const handleSaveAddress = async (address) => {
        setSubmitOpen(true)
        setSuccess(false)
        setError(false)
        try {
            const res = await saveAddress(address)
            setSuccess(!!res)
        } catch (error) {
            setError(true)
        }
    }

    const errorDeleteAddress = (menssage) =>
        Notify(menssage, variants.ERROR);

    const handleModalClose = () => {
        setOpenModal(false);
        setAddressToUpdate(null);
    }

    const handleOpenModalUpdate = (address) => {
        setAddressToUpdate(address);
        setOpenModal(true);
    }

    const handleOpenModalDelete = (address) => {
        if (address.isInvoice || address.isShipping) {
            errorDeleteAddress(`No se puede eliminar porque esta configurada como ${address.isInvoice ? "DIRECCIÓN DE FACTURACIÓN" : "DIRECCIÓN DE ENVIO"} `);
            return;
        }

        setAddressToDelete(address)
        setDeleteOpen(true)
    }

    const handleAcceptModalDelete = async () => {
        if (addressToDelete) {
            setDeleteOpen(false)
            setSubmitOpen(true)
            deleteAddress(addressToDelete)
                .then(() =>
                    setSuccess(true)
                )
                .catch((e) => {
                    setError(true);
                    errorDeleteAddress(e.message);
                })
        }
    }

    const handleError = (event) => {
        setSubmitOpen(false)
        setSuccess(false);
        setError(false);
    }

    const handleSuccess = (event) => {
        handleModalClose();
        setAddressToDelete(null);
        setSubmitOpen(false)
        setSuccess(false)
        setError(false)
    }

    return (
        <>
            <Paper className={classes.paper}>
                <div className={classes.column}>
                    <DataGrid
                        titleGrid="Direcciones"
                        rows={customer?.addresses || []}
                        loading={loading}
                        columns={columns}
                        paginationProps={{
                            count: totalPage,
                            page: pageNumber,
                            onChange: changePage
                        }}
                        {...!disabled && {
                            actions: ({ row }) => (
                                <>
                                    <EditButton
                                        onClick={() => handleOpenModalUpdate(row)}
                                    />
                                    <DeleteButton
                                        onClick={() => handleOpenModalDelete(row)}
                                    />
                                </>
                            )
                        }}
                    />
                    {
                        !disabled &&
                        <Button
                            name='createAddressButton'
                            onClick={() => setOpenModal(true)}
                            variant='contained'
                            color='primary'
                            startIcon={<Add />}
                            sx={{ mt: 1 }}
                        >
                            Agregar dirección
                        </Button>
                    }
                </div>
            </Paper>
            {
                openModal &&
                <CreateAddress
                    onSave={handleSaveAddress}
                    address={addressToUpdate}
                    modalProps={{
                        open: openModal,
                        onClose: handleModalClose
                    }}
                />
            }
            {
                !!addressToDelete &&
                <ModalConfirm
                    open={deleteOpen}
                    message={`¿Esta seguro que desea eliminar la dirección (${addressToDelete.street} ${addressToDelete.number})?`}
                    onAccept={handleAcceptModalDelete}
                    onCancel={() => setDeleteOpen(false)}
                    onClose={() => setDeleteOpen(false)}
                />
            }
            <ModalSuccess
                open={submitOpen}
                intervale={500}
                success={success}
                onSuccess={handleSuccess}
                successText={`Dirección ${addressToUpdate ? "modificada" : addressToDelete ? "borrada" : "creada"} con éxito`}
                error={error}
                onError={handleError}
                errorText={`No se pudo ${addressToUpdate ? "modificar" : addressToDelete ? "borrar" : "crear"} la dirección`}
            />
        </>
    )
}

export default Address;
